<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row>
        <SendCampaignDialog v-model="showSendCampaignDialog"></SendCampaignDialog>

        <v-col cols="12" v-if="campaign.status === 'inReview'">
            <v-alert style="border-radius: 3px; border: none;"
                     :value="true"
                     type="info">
                <v-row align="center" class="ml-2">
                    <span class="align-center">
                    {{ $t('general.campaignReadyAndWaitingToBeSent') }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn class="hidden-md-and-down mr-2"
                           depressed
                           color="kbWhite"
                           :disabled="loading"
                           @click="showSendCampaignDialog = true"
                           outlined>
                        {{ $t('general.schedule') }}
                        <v-icon right>event</v-icon>
                    </v-btn>

                    <v-btn class="hidden-md-and-down mr-2"
                           color="kbWhite"
                           depressed
                           :loading="loading"
                           @click="sendCampaign"
                           outlined>
                        {{ $t('general.send') }}
                        <v-icon right>send</v-icon>
                    </v-btn>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon
                                   class="hidden-lg-and-up"
                                   v-on="on"
                                   :disabled="loading"
                                   @click="showSendCampaignDialog = true">
                                <v-icon color="white">event</v-icon>
                            </v-btn>
                        </template>

                        <span>{{ $t('general.scheduleCampaign') }}</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon
                                   class="hidden-lg-and-up"
                                   v-on="on"
                                   :loading="loading"
                                   @click="sendCampaign">
                                <v-icon color="white">send</v-icon>
                            </v-btn>
                        </template>

                        <span>{{ $t('general.sendCampaign') }}</span>
                    </v-tooltip>
                </v-row>
            </v-alert>
        </v-col>

        <v-col cols="12" class="mb-2 pb-0">
            <v-card color="kbWhite">
                <v-card-text>
                    <v-row class="pa-2"  align="center">
                        <h5 class="hidden-sm-and-up text-capitalize kbDarkBlueText--text">{{campaign.name}}</h5>
                        <h3 class="hidden-xs-only text-capitalize kbDarkBlueText--text" id="title">{{campaign.name}}</h3>
                        <v-spacer></v-spacer>
                        <v-btn v-if="status === $tc('general.sent', 0).toUpperCase()" color="kbPurple" dark @click="exportCampaign()"
                               :loading="exporting">
                            <v-icon small left>fas fa-file-excel</v-icon>
                            {{ $t('general.export') }}
                        </v-btn>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-text>
                    <v-row align="center">
                      <v-col cols="12"
                             :md="campaign.status !== 'draft' && campaign.status !== 'inReview' ? '5' : '12'">
                        <v-list two-line
                                class="pa-0">
                          <v-list-item>
                            <v-list-item-action>
                              <v-icon large color="kbDarkBlue">info</v-icon>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title>{{status}}</v-list-item-title>
                              <v-list-item-subtitle>{{ $t('general.campaignStatus') }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-action>
                              <v-icon large color="kbDarkBlue">people</v-icon>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title>{{campaign.totalUsers | formatNumber}}
                                {{ $t('general.people') }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                {{campaign.listName ? campaign.listName : $t('general.campaignScope') }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item v-if="campaign.sms && campaign.sms.totalMultiparts">
                            <v-list-item-action>
                              <v-icon large color="kbDarkBlue">mdi-message-bulleted</v-icon>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title>
                                {{ campaign.sms.totalMultiparts | formatNumber }}
                                {{ campaign.status !== 'sent'
                                  ? $t('general.messagesToBeSent')
                                  : $t('general.sentMessages') }}
                              </v-list-item-title>
                              <v-list-item-subtitle>{{campaign.status !== 'sent'
                                ? $t('general.thisValueCouldChange')
                                : $t('general.finalValue') }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-action>
                              <v-icon large color="kbDarkBlue">send</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title v-if="campaign.createdAt">
                                {{campaign.createdAt | moment('DD/MM/YYYY hh:mm a')}}
                              </v-list-item-title>
                              <v-list-item-subtitle>{{ $t('general.creationDate') }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item v-if="campaign.status === 'sent'">
                            <v-list-item-action>
                              <v-icon large color="kbDarkBlue">send</v-icon>
                            </v-list-item-action>

                            <v-list-item-content>
                              <v-list-item-title v-if="campaign.date">{{campaign.date |
                                moment('DD/MM/YYYY hh:mm a')}}
                              </v-list-item-title>
                              <v-list-item-subtitle>{{ $t('general.sendingDate') }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>

                      <v-col cols="12"
                             md="7"
                             v-if="campaign.status !== 'draft' && campaign.status !== 'inReview'">
                        <div class="card-chart">
                          <BarChart :chart-data="campaignData"
                                    :options="chartOptions"
                                    ref="barChart" />
                        </div>
                      </v-col>

                      <v-col cols="12"
                             class="hidden-sm-and-down"
                             v-if="campaign.status !== 'draft' &&
                                   campaign.status !== 'inReview' &&
                                   campaign.totalSent &&
                                   (campaign.totalOpened || campaign.totalClicked) && campaign.type !== 'sms'">
                        <EfectiveDataChart :campaign="campaign" />
                      </v-col>

                      <v-col cols="12">
                        <CampaignFiles
                          :campaign-files="campaign.attachments || []"
                          :campaign-id="campaign._id || ''"
                          :campaign-status="campaign.status || ''"
                          @getCampaign="getCampaign()"
                        />
                      </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col class="pb-0 pt-8" cols="12" v-if="campaign.status !== 'draft' && campaign.status !== 'inReview'">
            <h4 class="kbDarkBlueText--text">{{ $t('general.campaignProgress') }}</h4>
        </v-col>

        <v-col cols="12" v-if="campaign.status !== 'draft' && campaign.status !== 'inReview'">
            <v-card elevation="0" text color="rgba(255, 0, 0, 0)">
                <v-card-text class="pa-0">
                    <v-row>
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.sent">
                            <CampaignCounterCard :progressCount="progress.sent"
                                                 :cardLabel="statusProps.sent.pluralLabel"
                                                 :upperRightIcon="statusProps.sent.icon"
                                                 :upperRightIconColor="statusProps.sent.color"
                                                 :progressColor="statusProps.sent.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalSent"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.delivered">
                            <CampaignCounterCard :progressCount="progress.delivered"
                                                 :cardLabel="statusProps.delivered.pluralLabel"
                                                 :upperRightIcon="statusProps.delivered.icon"
                                                 :upperRightIconColor="statusProps.delivered.color"
                                                 :progressColor="statusProps.delivered.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalDelivered"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.rejected">
                            <CampaignCounterCard :progressCount="progress.rejected"
                                                 :cardLabel="statusProps.rejected.pluralLabel"
                                                 :upperRightIcon="statusProps.rejected.icon"
                                                 :upperRightIconColor="statusProps.rejected.color"
                                                 :progressColor="statusProps.rejected.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalRejected"
                            />
                        </v-col>
                        <!--
                        <v-flex xs12 sm4 md4 v-if="displayCampaignProgress.multiparts && !hiddenMoreCounters">
                          <CampaignCounterCard  :progressCount="progress.multiparts" :cardLabel="statusProps.multiparts.pluralLabel"
                                                :upperRightIcon="statusProps.multiparts.icon" :upperRightIconColor="statusProps.multiparts.color"
                                                :progressColor="statusProps.multiparts.color" :campaignTypeLabel="campaignTypeLabel"
                                                :campaignTotal="campaign.sms.totalMultiparts"
                          />
                        </v-flex>
                        -->
<!--                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.deferral && !hiddenMoreCounters">
                            <CampaignCounterCard :progressCount="progress.deferral"
                                                 :cardLabel="statusProps.deferral.pluralLabel"
                                                 :upperRightIcon="statusProps.deferral.icon"
                                                 :upperRightIconColor="statusProps.deferral.color"
                                                 :progressColor="statusProps.deferral.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalDeferral"
                            />
                        </v-col>-->
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.open  && !hiddenMoreCounters">
                            <CampaignCounterCard :progressCount="progress.open"
                                                 :cardLabel="statusProps.open.pluralLabel"
                                                 :upperRightIcon="statusProps.open.icon"
                                                 :upperRightIconColor="statusProps.open.color"
                                                 :progressColor="statusProps.open.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalOpened"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.spam  && !hiddenMoreCounters">
                            <CampaignCounterCard :progressCount="progress.spam"
                                                 :cardLabel="statusProps.spam.pluralLabel"
                                                 :upperRightIcon="statusProps.spam.icon"
                                                 :upperRightIconColor="statusProps.spam.color"
                                                 :progressColor="statusProps.spam.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalSpam"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.click  && !hiddenMoreCounters">
                            <CampaignCounterCard :progressCount="progress.click"
                                                 :cardLabel="statusProps.click.pluralLabel"
                                                 :upperRightIcon="statusProps.click.icon"
                                                 :upperRightIconColor="statusProps.click.color"
                                                 :progressColor="statusProps.click.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalClicked"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.blacklist  && !hiddenMoreCounters">
                            <CampaignCounterCard :progressCount="progress.blacklist"
                                                 :cardLabel="statusProps.blacklist.pluralLabel"
                                                 :upperRightIcon="statusProps.blacklist.icon"
                                                 :upperRightIconColor="statusProps.blacklist.color"
                                                 :progressColor="statusProps.blacklist.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalBlacklist"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.unsub  && !hiddenMoreCounters">
                            <CampaignCounterCard :progressCount="progress.unsub"
                                                 :cardLabel="statusProps.unsub.pluralLabel"
                                                 :upperRightIcon="statusProps.unsub.icon"
                                                 :upperRightIconColor="statusProps.unsub.color"
                                                 :progressColor="statusProps.unsub.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalUnsub"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.hardBounce  && !hiddenMoreCounters">
                            <CampaignCounterCard :progressCount="progress.hardBounce"
                                                 :cardLabel="statusProps.hardBounce.pluralLabel"
                                                 :upperRightIcon="statusProps.hardBounce.icon"
                                                 :upperRightIconColor="statusProps.hardBounce.color"
                                                 :progressColor="statusProps.hardBounce.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalHardBounced"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.softBounce  && !hiddenMoreCounters">
                            <CampaignCounterCard :progressCount="progress.softBounce"
                                                 :cardLabel="statusProps.softBounce.pluralLabel"
                                                 :upperRightIcon="statusProps.softBounce.icon"
                                                 :upperRightIconColor="statusProps.softBounce.color"
                                                 :progressColor="statusProps.softBounce.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalSoftBounced"
                            />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" v-if="displayCampaignProgress.whitelist  && !hiddenMoreCounters">
                            <CampaignCounterCard :progressCount="progress.whitelist"
                                                 :cardLabel="statusProps.whitelist.pluralLabel"
                                                 :upperRightIcon="statusProps.whitelist.icon"
                                                 :upperRightIconColor="statusProps.whitelist.color"
                                                 :progressColor="statusProps.whitelist.color"
                                                 :campaignTypeLabel="campaignTypeLabel"
                                                 :campaignTotal="campaign.totalWhitelist"
                            />
                        </v-col>
                    </v-row>
                    <v-fab-transition v-if="showMoreCountersBtn">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        v-show="hiddenMoreCounters"
                                        v-on="on"
                                        @click="hiddenMoreCounters = !hiddenMoreCounters"
                                        color="kbPurple"
                                        dark
                                        absolute
                                        bottom
                                        right
                                        fab>
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('general.moreCounters') }}</span>
                        </v-tooltip>
                    </v-fab-transition>
                    <v-fab-transition v-if="showMoreCountersBtn">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-show="!hiddenMoreCounters"
                                       v-on="on"
                                       @click="hiddenMoreCounters = !hiddenMoreCounters"
                                       color="kbPurple"
                                       dark
                                       absolute
                                       bottom
                                       right
                                       fab>
                                    <v-icon>remove</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('general.lessCounters') }}</span>
                        </v-tooltip>
                    </v-fab-transition>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12" v-if="campaign.status === 'draft'">
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="font-weight-bold">
                            {{ $t('general.importingPeopleProgress') }}
                            <v-spacer></v-spacer>
                            <v-icon color="blue">cloud_upload</v-icon>
                        </v-card-title>
                        <v-card-text>
                            <v-row class="ma-0"   >
                                <v-col class="text-center" cols="12" >
                                    <v-progress-circular color="blue"
                                                         :rotate="-90"
                                                         :size="100"
                                                         :width="15"
                                                         :value="progressCampaign">
                                        {{campaignProgress.totalImported}}
                                    </v-progress-circular>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-text class="pa-6">
                            <v-row>
                                {{ $t('general.importedPeople') }}
                                <v-spacer></v-spacer>
                                {{campaignProgress.totalImported | formatNumber}}&nbsp;<span class="grey--text">({{progressCampaign}}%)</span>
                            </v-row>

                            <v-row>
                                {{ $t('general.peopleAmount') }}
                                <v-spacer></v-spacer>
                                {{campaignProgress.totalUsers | formatNumber}}
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>

        <v-col cols="12">
            <v-tabs v-model="tab"
                    background-color="grey lighten-1"
                    dark
                    grow
                    height="50"
                    v-if="campaign.importErrors"
                    active-class="primary white--text">
                <v-tabs-slider style="display: none;"></v-tabs-slider>
                <v-tab>{{ $t('general.people') }}</v-tab>

                <v-tab v-if="campaign.type === 'massive' && campaign.importErrors">{{ $t('general.importingErrors') }}</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" style="background-color: transparent">
                <v-tab-item class="kbWhite">
                    <CampaignsUsers :statusProps="statusProps"></CampaignsUsers>
                </v-tab-item>

                <v-tab-item v-if="campaign.type === 'massive'">
                    <v-card color="kbWhite">
                        <v-card-text class="pa-0">
                            <ImportErrors></ImportErrors>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import campaignsService from '@/services/campaignsService'
import notifications from '@/libs/notifications'
import BarChart from '@/components/chart/BarChart'
import CampaignsUsers from '@/pages/App/Communications/CampaignDetails/CampaignsUsers.vue'
import EfectiveDataChart from '@/pages/App/Communications/CampaignDetails/Charts/EfectiveDataChart'
import ImportErrors from '@/pages/App/Communications/CampaignDetails/ImportErrors.vue'
import CampaignCounterCard from '@/pages/App/Communications/CampaignDetails/CampaignCounterCard.vue'
import SendCampaignDialog from '@/pages/App/Communications/CampaignDetails/SendCampaignDialog.vue'
import CampaignFiles from '@/pages/App/Communications/CampaignDetails/CampaignFiles'

export default {
  components: { CampaignFiles, BarChart, CampaignsUsers, EfectiveDataChart, ImportErrors, CampaignCounterCard, SendCampaignDialog },
  computed: {
    ...mapState({
      campaign: state => state.campaigns.campaign,
      selectedApp: state => state.apps.selectedApp,
      displayCampaignProgress: function (state) {
        let displayCampaignProgress = {
          sent: true,
          delivered: true,
          rejected: true
        }
        if ((this.campaign.type === 'sms' || this.campaign.type === 'massive') && this.campaign.sms !== undefined) {
          // this.showMoreCountersBtn = true
          displayCampaignProgress = {
            ...displayCampaignProgress,
            multiparts: true
          }
        }
        if (this.campaign.type === 'email') {
          this.showMoreCountersBtn = true
          displayCampaignProgress = {
            ...displayCampaignProgress,
            deferral: true,
            hardBounce: true,
            softBounce: true,
            open: true,
            click: true,
            spam: true,
            unsub: true,
            blacklist: true,
            whitelist: true
          }
        }
        return displayCampaignProgress
      },
      progress: function (state) {
        const calcProgress = (total) => {
          try {
            if (this.campaign.totalUsers === 0 || !total) return 0
            return parseInt((total * 100) / this.campaign.totalUsers)
          } catch (e) {
            return 0
          }
        }
        const progress = {}
        try {
          progress.delivered = calcProgress(this.campaign.totalDelivered)
          progress.sent = calcProgress(this.campaign.totalSent)
          progress.rejected = calcProgress(this.campaign.totalRejected)
          progress.blacklist = calcProgress(this.campaign.totalBlacklist)
          progress.click = calcProgress(this.campaign.totalClicked)
          progress.deferral = calcProgress(this.campaign.totalDeferral)
          progress.hardBounce = calcProgress(this.campaign.totalHardBounced)
          progress.open = calcProgress(this.campaign.totalOpened)
          progress.softBounce = calcProgress(this.campaign.totalSoftBounced)
          progress.spam = calcProgress(this.campaign.totalSpam)
          progress.unsub = calcProgress(this.campaign.totalUnsub)
          progress.whitelist = calcProgress(this.campaign.totalWhitelist)
          if (this.campaign.sms) progress.multiparts = calcProgress(this.campaign.sms.totalMultiparts)
        } catch (err) {
          console.log(err)
        }
        return progress
      }
    }),
    progressCampaign () {
      if (this.campaignProgress.totalUsers === 0) return 0
      return parseInt((this.campaignProgress.totalImported * 100) / this.campaignProgress.totalUsers)
    },
    status () {
      if (this.campaign.status === 'sending') return this.$t('general.sending').toUpperCase()
      if (this.campaign.status === 'sent') return this.$tc('general.sent', 0).toUpperCase()
      if (this.campaign.status === 'inReview') return this.$t('general.onStandBy').toUpperCase()
      if (this.campaign.status === 'draft') return this.$t('general.onDraft').toUpperCase()
      if (this.campaign.status === 'schedule') return this.$t('general.scheduled').toUpperCase()
      return ''
    },
    dynamicFlexStatusCampaign: function (state) {
      if (this.status && this.displayCampaignProgress.multiparts) {
        return { cols: 12, md: 12, lg: 12 }
      }
      return { cols: 12, md: 4, lg: 4 }
    },
    dynamicFlexCommonCounters: function (state) {
      if (this.displayCampaignProgress.multiparts) {
        return { cols: 12, md: 6, lg: 6 }
      }
      return { cols: 12, md: 4, lg: 4 }
    },
    dynamicFlexDates: function (state) {
      if (this.campaign.status === 'sent' && this.campaign.date) {
        return { cols: 12, md: 6, lg: 6 }
      }
      return { cols: 12, md: 12, lg: 12 }
    },
    campaignTypeLabel () {
      if (this.campaign.type === 'sms') return 'Sms'
      if (this.campaign.type === 'email') return 'Email'
      if (this.campaign.type === 'massive') return 'Sms'
      return ''
    },
    campaignData () {
      const datasets = [{
        backgroundColor: 'rgba(251,144,51,0.6)',
        borderColor: 'rgb(251, 99, 64)',
        label: this.$t('general.campaignInformation'),
        data: [],
        showLine: true
      }]
      let labels = []
      if (this.campaign) {
        const {
          totalSent = 0,
          totalDelivered = 0,
          totalRejected = 0,
          // totalDeferral = 0,
          totalOpened = 0,
          totalSpam = 0,
          totalClicked = 0,
          totalBlacklist = 0,
          totalUnsub = 0,
          totalHardBounced = 0,
          totalSoftBounced = 0,
          totalWhitelist = 0
        } = this.campaign
        let campaignData = [
          { key: this.statusProps.sent.pluralLabel, value: totalSent },
          { key: this.statusProps.delivered.pluralLabel, value: totalDelivered },
          { key: this.statusProps.rejected.pluralLabel, value: totalRejected },
          // { key: this.statusProps.deferral.pluralLabel, value: totalDeferral },
          { key: this.statusProps.open.pluralLabel, value: totalOpened },
          { key: this.statusProps.spam.pluralLabel, value: totalSpam },
          { key: this.statusProps.click.pluralLabel, value: totalClicked },
          { key: this.statusProps.blacklist.pluralLabel, value: totalBlacklist },
          { key: this.statusProps.unsub.pluralLabel, value: totalUnsub },
          { key: this.statusProps.hardBounce.pluralLabel, value: totalHardBounced },
          { key: this.statusProps.softBounce.pluralLabel, value: totalSoftBounced },
          { key: this.statusProps.whitelist.pluralLabel, value: totalWhitelist }
        ]
        if (this.campaign.type === 'sms') {
          campaignData = [...campaignData.slice(0, 3)]
        }
        labels = campaignData.map(item => item.key)
        datasets[0].data = campaignData.map(item => item.value)
      }
      return { datasets, labels }
    },
    chartOptions () {
      let options = {
        responsive: true,
        maintainAspectRatio: false
      }
      const darkThemeOptions = {
        legend: {
          labels: {
            fontColor: '#c4c4c4'
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              color: '#14192A'
            },
            ticks: {
              fontColor: '#c4c4c4'
            }
          }],
          xAxes: [{
            gridLines: {
              color: '#14192A'
            },
            ticks: {
              fontColor: '#c4c4c4'
            }
          }]
        }
      }
      if (this.$vuetify.theme.isDark) {
        options = { ...options, ...darkThemeOptions }
      }
      return options
    },
    statusProps () {
      return {
        all: {
          singularLabel: this.$t('general.all'),
          filterValue: ''
        },
        pending: {
          singularLabel: this.$t('general.pending'),
          filterValue: 'pending'
        },
        sent: {
          icon: 'done',
          color: 'info',
          pluralLabel: this.$tc('general.sent', 2),
          singularLabel: this.$tc('general.sent', 1),
          filterValue: 'sent'
        },
        delivered: {
          icon: 'done_all',
          color: 'success',
          pluralLabel: this.$t('general.deliveredToCarrier'),
          singularLabel: this.$t('general.delivered'),
          filterValue: 'delivered'
        },
        rejected: {
          icon: 'not_interested',
          color: 'error',
          pluralLabel: this.$tc('general.rejected', 1),
          singularLabel: this.$tc('general.rejected', 0),
          filterValue: 'rejected'
        },
        deferral: {
          icon: 'hourglass_empty',
          color: 'info',
          pluralLabel: this.$tc('general.postponed', 1),
          singularLabel: this.$tc('general.postponed', 0),
          filterValue: 'deferral'
        },
        hardBounce: {
          icon: 'call_missed_outgoing',
          color: 'error',
          pluralLabel: this.$tc('general.hardRebound', 1),
          singularLabel: this.$tc('general.hardRebound', 0),
          filterValue: 'hard_bounce'
        },
        softBounce: {
          icon: 'call_missed_outgoing',
          color: 'info',
          pluralLabel: this.$tc('general.softRebound', 1),
          singularLabel: this.$tc('general.softRebound', 0),
          filterValue: 'soft_bounce'
        },
        open: {
          icon: 'drafts',
          color: 'success',
          pluralLabel: this.$tc('general.opened', 1),
          singularLabel: this.$tc('general.opened', 0),
          filterValue: 'open'
        },
        click: {
          icon: 'mouse',
          color: 'success',
          pluralLabel: 'Clicks',
          singularLabel: 'Click',
          filterValue: 'click'
        },
        spam: {
          icon: 'report',
          color: 'error',
          pluralLabel: this.$t('general.inSpam'),
          singularLabel: this.$t('general.inSpam'),
          filterValue: 'spam'
        },
        unsub: {
          icon: 'unsubscribe',
          color: 'error',
          pluralLabel: this.$tc('general.terminated', 1),
          singularLabel: this.$tc('general.terminated', 0),
          filterValue: 'unsub'
        },
        blacklist: {
          icon: 'insert_drive_file',
          color: 'error',
          pluralLabel: this.$t('general.inBlackList'),
          singularLabel: this.$t('general.inBlackList'),
          filterValue: 'blacklist'
        },
        whitelist: {
          icon: 'insert_drive_file',
          color: 'info',
          pluralLabel: this.$t('general.inWhiteList'),
          singularLabel: this.$t('general.inWhiteList'),
          filterValue: 'whitelist'
        },
        multiparts: {
          icon: 'mdi-message-bulleted',
          color: 'info',
          pluralLabel: this.$tc('general.messagePart', 1),
          singularLabel: this.$tc('general.messagePart', 0),
          filterValue: 'multiparts'
        }
      }
    }
  },
  created () {
    this.getCampaign()

    if (this.$socket.connected) {
      this.$socket.emit('campaignRoom', { jwt: this.$store.getters.token, campaign: this.$route.params.campaignid })
    } else {
      this.$socket.connect()
    }
  },
  data () {
    return {
      exporting: false,
      loading: false,
      campaignProgress: {
        totalImported: 0,
        totalUsers: 0
      },
      showMoreCountersBtn: false,
      tab: 0,
      hiddenMoreCounters: true,
      showSendCampaignDialog: false
    }
  },
  destroyed () {
    delete this.$options.sockets.campaignProgress
  },
  methods: {
    exportCampaign () {
      this.exporting = true
      campaignsService.exportCampaign(
        this.$store.getters.token,
        this.$store.getters.companyUuid,
        this.$store.getters.appUuid,
        this.campaign._id,
        { filename: this.campaign.name }
      ).then(() => {
        this.exporting = false
      }).catch((error) => {
        notifications.error(error.message)
        this.exporting = false
      })
    },
    async getCampaign () {
      await this.$store.dispatch('getCampaign', { campaignId: this.$route.params.campaignid })
    },
    getCampaignUsers (campaignId) {
      this.$store.dispatch('getCampaignUsersList', { campaignId })
    },
    sendCampaign () {
      const data = {
        campaignId: this.$route.params.campaignid,
        schedule: false
      }

      this.loading = true
      this.$store.dispatch('sendCampaign', data).then(() => {
        this.loading = false
      }).catch((error) => {
        this.loading = false
        notifications.error(error.message)
      })
    },
    updateCampaignInfo (data) {
      try {
        if (data.campaign.id !== this.$route.params.campaignid) {
          return
        }
        switch (data.code) {
          case 0:
            if (data.campaign.status === 'draft' && data.index > this.campaignProgress.totalImported) {
              this.$set(this.campaignProgress, 'totalImported', data.index)
              this.$set(this.campaignProgress, 'totalUsers', data.totalUsers)
              this.$set(this.campaign, 'status', data.campaign.status)
              if (data.index % 50 === 0) {
                this.getCampaignUsers(this.$route.params.campaignid)
              }
            }
            break
          case 1:
            if (data.campaign.status === 'draft' && data.index > this.campaignProgress.totalImported) {
              this.$set(this.campaignProgress, 'totalImported', data.index)
              this.$set(this.campaignProgress, 'totalUsers', data.totalUsers)
              if (data.index % 100 === 0) {
                this.getCampaignUsers(this.$route.params.campaignid)
              }
            } else {
              this.$store.commit('UPDATE_CAMPAIGN', data.campaign)
            }
            break
          case 2:
            this.$store.commit('UPDATE_CAMPAIGN', data.campaign)
            this.getCampaignUsers(this.$route.params.campaignid)
            break
          default:
            this.$store.commit('UPDATE_CAMPAIGN', data.campaign)
            this.getCampaignUsers(data.campaign.id)
            break
        }
      } catch (err) {
        console.log(err)
      }
    }
  },
  mounted () {
    this.$options.sockets.campaignProgress = (data) => {
      this.updateCampaignInfo(data)
    }
  },
  sockets: {
    connect: function () {
      this.$socket.emit('campaignRoom', { jwt: this.$store.getters.token, campaign: this.$route.params.campaignid })
    }
  },
  watch: {
    selectedApp (value) {
      this.$router.push(`/apps/${value.UUID}/campaigns`)
    }
  }
}
</script>

<style scoped>
.card-chart {
  border-radius: 10px;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  padding: 10px;
}
</style>
